/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef } from "react";
import { PageLoader } from "../../components/PageLoader/PageLoader";
import { useSelector } from "react-redux";
import { IStoreState } from "../../redux/initialStoreState";
import { LoadState } from "../../constants/enums";
import { PageContainer } from "../../components/container/PageContainer";
import {
  Box,
  Button,
  Grid,
  Stack,
  Typography,
  Snackbar,
  Alert,
  List,
  ListItem,
  ListItemText,
  ToggleButton,
  ToggleButtonGroup,
  Autocomplete,
  Chip,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  Menu,
  MenuItem,
} from "@mui/material";
import { useDispatchWrapper } from "../../hooks";

import { useFormik } from "formik";
import { useAuth } from "../../contexts/AuthProvider/AuthProvider";
import { StandardCard } from "../../components/Cards";
import {
  CustomFormLabel,
  CustomTextField,
} from "../../components/formsComponents";
import { Editor } from "../../components/Editor/Editor";
import { useBillingCompanyContext } from "../../providers/BillingCompanyProvider";
import { PreviewTemplate } from "../../components/Preview/PreviewTemplate";
import WhatsappBgImg from "../../assets/whatsapp_bg_img.jpg";
import { useNavigate, useParams } from "react-router-dom";
import { Breadcrumb } from "../../layout/fullLayout/breadcrumb/Breadcrumb";
import { IBreadcrumbProps } from "../../layout/fullLayout/breadcrumb/IBreadcrumbProps";
import {
  IQuickReplyAttachment,
  IQuickReplyTemplateData,
} from "../../redux/quickReplyTemplates/quickReplyTemplate.types";
import {
  clearQuickReplyTemplateState,
  fetchQuickReplyTemplateAsync,
  upsertQuickReplyTemplate,
} from "../../redux/quickReplyTemplates/quickReplyTemplateAction";
import { FileUpload } from "../../components/FileUpload/components/FileUpload";
import { uploadMultipleFile } from "../../components/FileUpload/utils";
import { getUniqueId } from "../../helpers";
import { fetchTemplateModuleSubModuleAsync } from "../../redux/templates/templateActions";
import { ISelectOption } from "../../constants/types";

interface IManageQuickReplyTemplateProps {
  onSaveSuccess: (templateData: IQuickReplyTemplateData) => void;
  templateName?: string;
  templateData?: IQuickReplyTemplateData;
  fromRightPanel?: boolean;
  isFromRecommendedFromRightpanel?: boolean;
  recommendedTemplateDataFromRightpanel?: IQuickReplyTemplateData;
  saveRef?: React.MutableRefObject<(() => void) | null>;
}

export const ManageQuickReplyTemplate: React.FC<
  IManageQuickReplyTemplateProps
> = ({
  templateName,
  templateData,
  onSaveSuccess,
  fromRightPanel = false,
  isFromRecommendedFromRightpanel = false,
  recommendedTemplateDataFromRightpanel = null,
  saveRef,
}) => {
    const CompanyOutletContext = useBillingCompanyContext();
    const navigate = useNavigate();
    const { quickReplyTemplateName } = useParams();
    const isUpdate = quickReplyTemplateName || templateName ? true : false;
    const { user } = useAuth();

    const [submitAttempted, setSubmitAttempted] = React.useState(false);
    const [showError, setShowError] = React.useState<Partial<
      Record<keyof IQuickReplyTemplateData, string>
    > | null>(null);

    const [uploadedFile, setUploadedFile] = React.useState<File | null>(null);
    const [columnOptions, setColumnOptions] = React.useState<ISelectOption[]>([]);
    const [variableAnchorEl, setVariableAnchorEl] = React.useState<null | HTMLElement>(null);

    const BCrumb: IBreadcrumbProps["items"] = [
      {
        to: "/dashboard",
        title: "dashboard",
      },
      {
        to: "/quick-reply-templates",
        title: "Quick Reply Templates",
      },
      {
        title:
          templateName || quickReplyTemplateName
            ? "Edit Quick Reply Template"
            : "Create Quick Reply Template",
      },
    ];

    const {
      data: quickReplyTemplateData,
      loading: quickReplyTemplateDataLoading,
      error: quickReplyTemplateDataError,
    } = useSelector(
      (storeState: IStoreState) =>
        storeState.quickReplyTemplate.quickReplyTemplateData,
    );

    const [bodyCharCount, setBodyCharCount] = React.useState(0);

    const currentTemplate = templateData ? templateData : quickReplyTemplateData;
    const initialValues = React.useMemo(() => {
      let initialAttachment: IQuickReplyAttachment | null = null;
      if (currentTemplate?.attachment) {
        if (
          typeof currentTemplate.attachment === "object" &&
          !Array.isArray(currentTemplate.attachment)
        ) {
          initialAttachment = {
            media_type: currentTemplate.attachment.media_type || "document",
            url: currentTemplate.attachment.url || "",
            filename: currentTemplate.attachment.filename || "",
            example: currentTemplate.attachment.example || "",
          };
        } else if (
          Array.isArray(currentTemplate.attachment) &&
          currentTemplate.attachment.length > 0
        ) {
          initialAttachment = {
            media_type: "document",
            url: "",
            filename: currentTemplate.attachment[0] || "",
            example: currentTemplate.attachment[0] || "",
          };
        }
      }

      return {
        ...(currentTemplate || {}),
        name: currentTemplate?.name || "",
        text: currentTemplate?.text || "",
        scope:
          currentTemplate?.category ||
          (currentTemplate?.user_uuid ? "own" : "public") ||
          "public",
        source_table: currentTemplate?.source_table || "latest_leads",
        tags: currentTemplate?.tags || [],
        type: currentTemplate?.type || "quick_reply",
        attachment: initialAttachment,
        master_quick_reply_template_uuid:
          currentTemplate?.master_quick_reply_template_uuid || null,
        status: currentTemplate?.status || "ACTIVE",
      };
    }, [currentTemplate]);

    const {
      values,
      errors,
      setFieldValue,
      setValues,
      handleChange,
      handleSubmit,
      validateForm,
    } = useFormik({
      initialValues,
      enableReinitialize: true,

      validate: (values) => {
        const errors: any = {};
        if (!values.text) {
          errors.text = "Message is required!.";
        }

        if (!values.name) {
          errors.name = "Template Name is required!.";
        }

        return errors;
      },
      onSubmit: async (values: any) => {
        setSubmitAttempted(true);

        const isTemplateType = values.type === "template";

        let uploadedFilePath =
          values.attachment?.example || values.attachment?.filename || "";
        if (isTemplateType && uploadedFile) {
          try {
            const uploadRes = await uploadMultipleFile(
              [
                {
                  key: getUniqueId(),
                  file: uploadedFile,
                  name: uploadedFile.name,
                  path: null,
                },
              ],
              "QUICK_REPLY_TEMPLATE",
              { title: values.name || "quick_reply" },
            );
            if (
              uploadRes?.paths &&
              uploadRes.paths.length > 0 &&
              uploadRes.paths[0]
            ) {
              uploadedFilePath = uploadRes.paths[0];
            }
          } catch (err) {
            console.error("Failed to upload attachment file", err);
          }
        }

        const finalAttachment =
          isTemplateType && values.attachment
            ? {
                media_type: values.attachment.media_type || "document",
                url: values.attachment.url || "",
                filename:
                  values.attachment.filename ||
                  uploadedFile?.name ||
                  "Quotation.pdf",
                example:
                  uploadedFilePath ||
                  values.attachment.example ||
                  uploadedFile?.name ||
                  "",
              }
            : null;

        const updatedValues: IQuickReplyTemplateData = {
          ...values,
          company_outlet_uuid: CompanyOutletContext.comapny.company_outlet_uuid,
          text: convertHtmlToMarkdown(values.text),
          user_uuid: values.scope === "own" ? user.userUuid : null,
          category: values.scope || "public",
          type: values.type || "quick_reply",
          attachment: finalAttachment,
          master_quick_reply_template_uuid:
            values.master_quick_reply_template_uuid || null,
          status: values.status || "ACTIVE",
        };

        dispatch(
          upsertQuickReplyTemplate(
            updatedValues as IQuickReplyTemplateData,
            (isSuccess, templateData) => {
              if (isSuccess) {
                fromRightPanel
                  ? onSaveSuccess(templateData as IQuickReplyTemplateData)
                  : navigate("/quick-reply-templates");
              }
            },
          ),
        );
      },
    });

    const handleGlobalSaveClick = async () => {
      const formErrors = await validateForm();
      setSubmitAttempted(true);
      setShowError(
        formErrors as Partial<Record<keyof IQuickReplyTemplateData, string>>,
      );
      if (
        Object.keys(
          formErrors as Partial<Record<keyof IQuickReplyTemplateData, string>>,
        ).length > 0
      ) {
        return;
      }
      setShowError(null);
      handleSubmit();
    };

    React.useEffect(() => {
      if (saveRef) {
        saveRef.current = handleGlobalSaveClick;
      }
    }, [saveRef, values, errors]);

    const editorRef = useRef<{
      insertTextAtCursor: (text: string) => void;
    } | null>(null);

    const dispatch = useDispatchWrapper();

    React.useEffect(() => {
      dispatch(
        fetchTemplateModuleSubModuleAsync((modules) => {
          setColumnOptions(modules || []);
        }, values.source_table || "latest_leads"),
      );
    }, [values.source_table, dispatch]);

    const handleFileUpload = (file: File) => {
      setUploadedFile(file);
      setFieldValue("attachment", {
        media_type: values.attachment?.media_type || "document",
        url: values.attachment?.url || "",
        filename: values.attachment?.filename || file.name,
        example: file.name,
      });
    };

    const handleFileDelete = () => {
      setUploadedFile(null);
      if (values.attachment) {
        setFieldValue("attachment.filename", "");
        setFieldValue("attachment.example", "");
      }
    };

    const handleOpenVariableMenu = (
      event: React.MouseEvent<HTMLButtonElement>,
    ) => {
      setVariableAnchorEl(event.currentTarget);
    };

    const handleCloseVariableMenu = () => {
      setVariableAnchorEl(null);
    };

    const handleSelectVariable = (variableValue: string) => {
      const currentUrl = values.attachment?.url || "";
      const newUrl = currentUrl
        ? `${currentUrl}@@${variableValue}`
        : `@@${variableValue}`;
      setFieldValue("attachment.url", newUrl);
      handleCloseVariableMenu();
    };

    const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value
        .toLowerCase() // Convert to lowercase
        .replace(/\s+/g, "_") // Replace spaces with underscores
        .replace(/[^a-z0-9_]/g, ""); // Remove any other special characters

      setFieldValue("name", value);
    };

    const handleBodyChange = (html: string) => {
      const markdown = convertHtmlToMarkdown(html);
      setBodyCharCount(markdown.length);

      setFieldValue("text", html);
    };

    React.useEffect(() => {
      if (templateName) {
        dispatch(
          fetchQuickReplyTemplateAsync(
            templateName,
            CompanyOutletContext.comapny.company_outlet_uuid,
          ),
        );
      }

      return () => {
        dispatch(clearQuickReplyTemplateState());
      };
    }, [templateName]);

    function convertHtmlToMarkdown(html: string) {
      let orderCount = 0;

      let markdown = html
        // Bold → *text*
        .replace(/<strong>(.*?)<\/strong>/gi, "*$1*")
        // Italic → _text_
        .replace(/<em>(.*?)<\/em>/gi, "_$1_")
        // Paragraphs → keep double newlines
        .replace(/<p>(.*?)<\/p>/gi, (m, p1) => `${p1.trim()}\n\n`)
        // Line breaks → single newline
        .replace(/<br\s*\/?>/gi, "\n")
        // List items
        .replace(/<li[^>]*>(.*?)<\/li>/gi, (match, content, index, fullText) => {
          const textBeforeLi = fullText.substring(0, fullText.indexOf(match));
          const lastListTag = textBeforeLi.lastIndexOf("<ol");
          const isOrderedList =
            lastListTag !== -1 &&
            textBeforeLi.substring(lastListTag).indexOf("</ol") === -1;

          if (isOrderedList) {
            orderCount++;
            return `${orderCount}. ${content.trim()}\n`;
          }
          return `• ${content.trim()}\n`;
        })
        // Remove list wrappers
        .replace(/<\/?[uo]l[^>]*>/gi, "\n")
        // Images → alt text
        .replace(/<img[^>]*alt="([^"]*)"[^>]*>/gi, "$1")
        // Strip remaining tags
        .replace(/<\/?[^>]+(>|$)/g, "")
        // Decode &nbsp;
        .replace(/&nbsp;/g, " ")
        // Collapse *3+* newlines into 2 (to preserve blank lines between paragraphs)
        .replace(/\n{3,}/g, "\n\n")
        .trim();

      return markdown;
    }

    React.useEffect(() => {
      if (isUpdate) {
        dispatch(
          fetchQuickReplyTemplateAsync(
            quickReplyTemplateName,
            CompanyOutletContext.comapny.company_outlet_uuid,
            "",
          ),
        );
      }
    }, [quickReplyTemplateName, dispatch]);

    return (
      <>
        <PageLoader
          loading={quickReplyTemplateDataLoading === LoadState.InProgress}
          error={
            quickReplyTemplateDataError
              ? {
                message:
                  quickReplyTemplateDataError || "Error loading template",
              }
              : null
          }
        >
          <PageContainer
            title={
              templateName
                ? "Edit Quick Reply Template"
                : "Create Quick Reply Template"
            }
            description="this is inner page"
          >
            {!fromRightPanel && (
              <Breadcrumb title="Create Quick Reply Template" items={BCrumb} />
            )}
            <StandardCard
              renderWithoutCard={fromRightPanel}
              heading={
                templateName || quickReplyTemplateName
                  ? "Edit Quick Reply Template"
                  : !fromRightPanel
                    ? "Create Quick Reply Template"
                    : ""
              }
            >
              <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={3}>
                    <CustomFormLabel>Name</CustomFormLabel>
                    <CustomTextField
                      fullWidth
                      name="name"
                      value={values.name}
                      onChange={handleNameChange}
                      error={submitAttempted && errors.name ? true : false}
                      helperText={
                        submitAttempted && typeof errors.name === "string"
                          ? errors.name
                          : ""
                      }
                      placeholder="(eg: my_template_name, lowercase letters, and underscores only)"
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <CustomFormLabel>Table Name</CustomFormLabel>
                    <CustomTextField
                      fullWidth
                      name="source_table"
                      value={values.source_table}
                      onChange={handleChange}
                      placeholder="Table Name (default: latest_leads)"
                    />
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <CustomFormLabel>Type</CustomFormLabel>
                    <Box>
                      <ToggleButtonGroup
                        value={values.type || "quick_reply"}
                        exclusive
                        onChange={(_, val) => {
                          if (val) {
                            setFieldValue("type", val);
                          }
                        }}
                        size="small"
                        color="primary"
                        sx={{ height: "40px" }}
                      >
                        <ToggleButton
                          value="quick_reply"
                          sx={{ px: 2, textTransform: "none" }}
                        >
                          Quick Reply
                        </ToggleButton>
                        <ToggleButton
                          value="template"
                          sx={{ px: 2, textTransform: "none" }}
                        >
                          Template
                        </ToggleButton>
                      </ToggleButtonGroup>
                    </Box>
                  </Grid>

                  <Grid item xs={12} md={3}>
                    <CustomFormLabel>Category</CustomFormLabel>
                    <Box>
                      <ToggleButtonGroup
                        value={values.scope || "public"}
                        exclusive
                        onChange={(_, val) => {
                          if (val) {
                            setFieldValue("scope", val);
                          }
                        }}
                        size="small"
                        color="primary"
                        sx={{ height: "40px" }}
                      >
                        <ToggleButton
                          value="own"
                          sx={{ px: 3, textTransform: "capitalize" }}
                        >
                          Own
                        </ToggleButton>
                        <ToggleButton
                          value="public"
                          sx={{ px: 3, textTransform: "capitalize" }}
                        >
                          Public
                        </ToggleButton>
                      </ToggleButtonGroup>
                    </Box>
                  </Grid>

                  <Grid item xs={12}>
                    <CustomFormLabel>Tags</CustomFormLabel>
                    <Autocomplete
                      multiple
                      freeSolo
                      options={["chat", "leads"]}
                      value={values.tags || []}
                      onChange={(_, newValue) => {
                        setFieldValue("tags", newValue);
                      }}
                      renderTags={(value: readonly string[], getTagProps) =>
                        value.map((option: string, index: number) => {
                          const { key, ...tagProps } = getTagProps({ index });
                          return (
                            <Chip
                              variant="outlined"
                              label={option}
                              key={key}
                              {...tagProps}
                              size="small"
                            />
                          );
                        })
                      }
                      renderInput={(params) => (
                        <CustomTextField
                          {...params}
                          placeholder="Type and press Enter to add tags"
                        />
                      )}
                    />
                  </Grid>

                  <Grid item xs={12} md={fromRightPanel ? 6 : 8}>
                    <Grid container spacing={2}>
                      {values.type === "template" && (
                        <Grid item xs={12}>
                          <CustomFormLabel sx={{ fontWeight: 600 }}>
                            Attachment
                          </CustomFormLabel>
                          <FormControl>
                            <RadioGroup
                              row
                              value={
                                values.attachment
                                  ? values.attachment.media_type || "document"
                                  : "none"
                              }
                              onChange={(e) => {
                                const val = e.target.value;
                                if (val === "none") {
                                  setUploadedFile(null);
                                  setFieldValue("attachment", null);
                                } else {
                                  setFieldValue("attachment", {
                                    media_type: val,
                                    url: values.attachment?.url || "",
                                    filename:
                                      values.attachment?.filename ||
                                      uploadedFile?.name ||
                                      "",
                                    example:
                                      values.attachment?.example ||
                                      uploadedFile?.name ||
                                      "",
                                  });
                                }
                              }}
                            >
                              <FormControlLabel
                                value="none"
                                control={<Radio />}
                                label="None"
                              />
                              <FormControlLabel
                                value="document"
                                control={<Radio />}
                                label="Document"
                              />
                              <FormControlLabel
                                value="image"
                                control={<Radio />}
                                label="Image"
                              />
                              <FormControlLabel
                                value="video"
                                control={<Radio />}
                                label="Video"
                              />
                            </RadioGroup>
                          </FormControl>
                        </Grid>
                      )}

                      {values.type === "template" && values.attachment && (
                        <>
                          <Grid item xs={12}>
                            <CustomFormLabel sx={{ fontWeight: 600 }}>
                              URL
                            </CustomFormLabel>
                            <Stack
                              direction="row"
                              spacing={1}
                              alignItems="flex-start"
                            >
                              <CustomTextField
                                fullWidth
                                name="attachment.url"
                                value={values.attachment.url || ""}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>,
                                ) =>
                                  setFieldValue(
                                    "attachment.url",
                                    e.target.value,
                                  )
                                }
                                placeholder="e.g. @@rough_estimation_pdf or https://example.com/file.pdf"
                              />
                              {/* Add Variable logic commented out for now
                              <Button
                                variant="contained"
                                onClick={handleOpenVariableMenu}
                                sx={{
                                  minWidth: "auto",
                                  px: 2,
                                  height: "42px",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                + Add Variable
                              </Button>
                              <Menu
                                anchorEl={variableAnchorEl}
                                open={Boolean(variableAnchorEl)}
                                onClose={handleCloseVariableMenu}
                                PaperProps={{
                                  sx: { maxHeight: 300, width: "260px" },
                                }}
                              >
                                {columnOptions.length > 0 ? (
                                  columnOptions.map((col) => (
                                    <MenuItem
                                      key={col.value}
                                      onClick={() =>
                                        handleSelectVariable(
                                          col.value as string,
                                        )
                                      }
                                    >
                                      <ListItemText
                                        primary={col.label}
                                        secondary={`@@${col.value}`}
                                      />
                                    </MenuItem>
                                  ))
                                ) : (
                                  <MenuItem
                                    onClick={() =>
                                      handleSelectVariable("variable_name")
                                    }
                                  >
                                    <ListItemText primary="Insert @@variable_name" />
                                  </MenuItem>
                                )}
                              </Menu>
                              */}
                            </Stack>
                          </Grid>

                          <Grid item xs={12} md={6}>
                            <CustomFormLabel sx={{ fontWeight: 600 }}>
                              Upload File
                            </CustomFormLabel>
                            <FileUpload
                              value={
                                uploadedFile?.name ||
                                values.attachment.example ||
                                values.attachment.filename ||
                                ""
                              }
                              accept={
                                values.attachment.media_type === "image"
                                  ? "image/*"
                                  : values.attachment.media_type === "video"
                                    ? "video/*"
                                    : ".pdf,.doc,.docx,.txt,.xls,.xlsx,.ppt,.pptx"
                              }
                              onChange={handleFileUpload}
                              onDelete={handleFileDelete}
                              heading=""
                            />
                          </Grid>

                          <Grid item xs={12} md={6}>
                            <CustomFormLabel sx={{ fontWeight: 600 }}>
                              Filename
                            </CustomFormLabel>
                            <CustomTextField
                              fullWidth
                              name="attachment.filename"
                              value={
                                values.attachment.filename ||
                                uploadedFile?.name ||
                                ""
                              }
                              onChange={(
                                e: React.ChangeEvent<HTMLInputElement>,
                              ) =>
                                setFieldValue(
                                  "attachment.filename",
                                  e.target.value,
                                )
                              }
                              placeholder="e.g. Quotation.pdf"
                              helperText="Path or name of the uploaded file"
                            />
                          </Grid>
                        </>
                      )}

                      <Grid item xs={12} mt={1}>
                        <Typography variant="h3" fontWeight={600}>
                          Body
                        </Typography>
                        <Editor
                          content={values.text}
                          ref={editorRef}
                          height={fromRightPanel ? "55vh" : 300}
                          isFromQuickReply={true}
                          onChange={handleBodyChange}
                        />
                        <Stack>
                          <Stack direction={"row"} justifyContent={"start"}>
                            <Typography
                              variant="caption"
                              color={
                                bodyCharCount > 1024 ? "error" : "textSecondary"
                              }
                              sx={{ mr: 2 }}
                            >
                              {bodyCharCount}/1024 characters
                              {bodyCharCount > 1024 && " - Exceeds limit!"}
                            </Typography>
                            {submitAttempted && errors.text && (
                              <Typography
                                variant="caption"
                                color="error"
                                display="block"
                              >
                                {submitAttempted &&
                                typeof errors.text === "string"
                                  ? errors.text
                                  : ""}
                              </Typography>
                            )}
                          </Stack>
                        </Stack>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={fromRightPanel ? 6 : 4} mt={2}>
                    <Typography variant="h3" fontWeight={600}>
                      Preview Template
                    </Typography>
                    <Box
                      p={2}
                      pt={4}
                      borderRadius={2}
                      sx={{
                        backgroundColor: "#efeae2",
                        backgroundImage: `url(${WhatsappBgImg})`,
                        backgroundRepeat: "repeat",
                        backgroundSize: "auto",
                        backgroundBlendMode: "multiply",
                        minHeight: fromRightPanel ? "55vh" : "300px",
                        height: fromRightPanel ? "55vh" : "auto",
                        overflow: "auto",
                      }}
                    >
                      <PreviewTemplate
                        template={{
                          ...values,
                          attachment:
                            values.type === "template" && values.attachment
                              ? {
                                  media_type:
                                    values.attachment.media_type || "document",
                                  url: values.attachment.url || "",
                                  filename:
                                    values.attachment.filename ||
                                    uploadedFile?.name ||
                                    "Quotation.pdf",
                                  example:
                                    (uploadedFile
                                      ? URL.createObjectURL(uploadedFile)
                                      : values.attachment.example) ||
                                    values.attachment.filename ||
                                    "",
                                }
                              : null,
                          header:
                            (values.type === "template" && values.attachment
                              ? {
                                  type: "HEADER",
                                  format: (
                                    values.attachment.media_type || "DOCUMENT"
                                  ).toUpperCase() as
                                    | "IMAGE"
                                    | "DOCUMENT"
                                    | "TEXT"
                                    | "LOCATION"
                                    | "VIDEO",
                                  text: null,
                                  example: {
                                    header_text: [],
                                    header_handle: [
                                      (uploadedFile
                                        ? URL.createObjectURL(uploadedFile)
                                        : values.attachment.example) ||
                                        values.attachment.filename ||
                                        "",
                                    ] as any,
                                  },
                                }
                              : {
                                  type: "HEADER",
                                  format: null,
                                  text: null,
                                  example: {
                                    header_text: [],
                                    header_handle: null,
                                  },
                                }) as any,
                          body: {
                            type: "BODY",
                            text: values.text || "",
                            example: { body_text: [] },
                          },
                        }}
                        loading={quickReplyTemplateDataLoading}
                        isFromQuickReply={true}
                        headerMedia={
                          values.type === "template" ? uploadedFile : null
                        }
                        headerType={
                          values.type === "template" &&
                          values.attachment?.media_type
                            ? values.attachment.media_type.toUpperCase()
                            : undefined
                        }
                      />
                    </Box>
                  </Grid>
                </Grid>

                {!fromRightPanel && (
                  <Stack
                    mt={3}
                    direction={"row"}
                    position={"fixed"}
                    bottom={20}
                    left={0}
                    right={20}
                    justifyContent={"right"}
                    spacing={2}
                  >
                    <Button
                      variant="contained"
                      type="button"
                      onClick={handleGlobalSaveClick}
                    >
                      Save
                    </Button>
                  </Stack>
                )}
              </form>
            </StandardCard>
          </PageContainer>
        </PageLoader>
        <Snackbar
          open={!!showError}
          autoHideDuration={5000}
          onClose={() => setShowError(null)}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ zIndex: 9999 }}
        >
          <Alert
            onClose={() => setShowError(null)}
            severity="error"
            sx={{ width: 400 }}
          >
            <List dense sx={{ p: 0 }}>
              {showError &&
                Object.values(showError).map((msg, index) => (
                  <ListItem key={index} sx={{ py: 0 }}>
                    <ListItemText primary={String(msg)} />
                  </ListItem>
                ))}
            </List>
          </Alert>
        </Snackbar>
      </>
    );
  };
